import { Trans } from 'react-i18next'

import { returnStatuses } from '@reveni-io/reveni-ui'

import { orderTransactionTypes } from '@/constants'

const RequestInfoMessage = ({ orderTransactionType, orderStatus }) => {
  if (orderStatus === returnStatuses.cancelled) {
    return (
      <p>
        <Trans i18nKey="exchangeMessageCancelledRequest">
          Tu solicitud de <strong>cambio de productos</strong> ha sido cancelada.
        </Trans>
      </p>
    )
  }

  return (
    <>
      {orderTransactionType === orderTransactionTypes.refund && (
        <p>
          <Trans i18nKey="refundMessageRequest">
            Tu solicitud de <strong>devolución de productos</strong> ha sido creada con éxito.
          </Trans>
        </p>
      )}

      {orderTransactionType === orderTransactionTypes.exchange && (
        <p>
          <Trans i18nKey="exchangeMessageRequest">
            Tu solicitud de <strong>cambio de productos</strong> ha sido creada con éxito.
          </Trans>
        </p>
      )}

      {orderTransactionType === orderTransactionTypes.mixed && (
        <p>
          <Trans i18nKey="mixedMessageRequest">
            Tu solicitud de <strong>cambio y devolución de productos</strong> ha sido creada con éxito.
          </Trans>
        </p>
      )}
    </>
  )
}

export default RequestInfoMessage
